import demiPic from "@/public/images/artists/demi.png";
import { Artist } from "@/types/types";

export const demi = {
  id: "34",
  name: "Demi",
  image: demiPic,
  description: `Say hello to "Demi", the powerhouse at the intersection of rock and pop. With a voice that exudes raw energy and edgy charisma, her vocals command attention, effortlessly transitioning from rock's gritty intensity to pop's infectious hooks.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdemi-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Rock", "Pop", "Gritty", "Punk", "Belting"],
      secondary: ["Singer", "Powerhouse"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 59,
        high: 71,
      },
    },
  },
} as const satisfies Artist;
